// Global vars
//variavel iframe recebe player
let iframe, player;
//var constante debug recebe falso
const debug = false;
//var constante hoje recebe nova data
const hoje = new Date();
// constante links recebe objeto

const redireciona = new Date("2026-06-18 00:00:00");

const redirect = () => {
  if (hoje >= redireciona) {
    // window.location.href = "https://andreimarani.com.br/lista-de-espera ";
  }
};
redirect();

const links = {
  desconto: "https://pay.hotmart.com/D66567366V?off=5xno9a8t&checkoutMode=10",
  preco_base: "https://pay.hotmart.com/D66567366V?off=9rcf97vp&checkoutMode=10",
  reabertura: "https://pay.hotmart.com/D66567366V?off=uanceie9&checkoutMode=10",
};

// constante liberação recebe objeto
const liberacao = {
  desconto: new Date("2026-01-01 07:59:59"),
  preco_base: new Date("2026-06-15 19:30:00"),
  reabertura: new Date("2026-06-19 08:00:00"),
};

// carrega a função
// window.onload = () => {
document.onreadystatechange = function () {
  if (document.readyState === "interactive") {
    //var constante studentsVideo recebe documento seletor da consulta id students-video-title
    const studentsVideo = document.querySelector("#students-video-title");

    // chama a função boletoParcelado
    // boletoParcelado();
    changeLink();
    // mostraValor();
    listaEspera();
  }
};

// ---------------------------------------------------------------------------------------

function listaEspera() {
  let registrationCourseButton = document.querySelector("#defalut-button");

  let waitingListButton = document.querySelector("#espera-button");

  let unitPrice = document.querySelector("#unit-price-container");

  let openCartPhrase = document.querySelector("#open-cart-phrase");

  let titleModal = document.querySelector("#staticBackdropLabel");

  let tagName = document.querySelector("#tag-name");

  let waitingList = document.querySelectorAll(".btn-waiting-list");

  let priceSection = document.querySelector("#section-values-row-full-value");

  // let modulesButton = document.querySelector("#modules-registration-button");

  let pageMainTitle = document.querySelector("#page-main-title");

  if (hoje >= redireciona) {
    // registrationCourseButton.classList.add("d-none");
    registrationCourseButton.remove();

    waitingListButton.classList.remove("d-none");

    // boletoButton.classList.add("d-none");
    boletoButton.remove();

    // unitPrice.classList.add("d-none");
    unitPrice.remove();

    // openCartPhrase.classList.add("d-none");
    openCartPhrase.remove();

    // priceSection.classList.add("d-none");
    priceSection.remove();

    // modulesButton.classList.add("d-none");
    // modulesButton.remove();

    pageMainTitle.innerHTML = "MATRÍCULAS ENCERRADAS!";

    titleModal.innerHTML = "Deixe seus dados para entrar na lista de espera";

    inputLink.value = "https://andreimarani.com.br/";

    tagName.value = "Lista de espera_2023";

    for (let i = 0; i < waitingList.length; i++) {
      waitingList[i].innerHTML = "QUERO ME INSCREVER NA LISTA DE ESPERA";
    }
  }
}

// ---------------------------------------------------------------------------------------

// var constante botão do boleto recebe documento seletor da consulta id boleto-button
const boletoButton = document.querySelector("#boleto-button");

// função boleto parcelado
const boletoParcelado = () => {
  // se hoje for maior  que a nova data de liberação
  if (hoje > liberacao.boleto_parcelado) {
    // remove o d-none da lista de clase do botão do boleto
    boletoButton.classList.remove("d-none");
  }
};

const inputLink = document.querySelector("#input-link");
if (inputLink) {
  // boletoButton.addEventListener("click", function () {
  //   if (hoje > liberacao.boleto_parcelado) {
  //     inputLink.value = links.boleto_parcelado;
  //   }
  // });
  const closeModal = document.querySelector("#close-modal");
  closeModal.addEventListener("click", function () {
    if (hoje > liberacao.desconto && hoje < liberacao.preco_base && inputLink) {
      inputLink.value = links.desconto;
    } else if (hoje > liberacao.preco_base) {
      inputLink.value = links.preco_base;
    }
  });
}

function changeLink() {
  if (hoje > liberacao.desconto && hoje < liberacao.preco_base && inputLink) {
    inputLink.value = links.desconto;
  } else if (hoje > liberacao.preco_base) {
    inputLink.value = links.preco_base;
  }
}

// constante staticBackdrop recebe documento seletor da consulta id staticBackdrop
const staticBackdrop = document.querySelector("#staticBackdrop");
// contante btns recebe documento todos seletores da consulta classe btn-home-header
const btns = document.querySelectorAll(".btn-home-header:not(.no-modal)");
// para cada btn do btns
btns.forEach((btn) => {
  // adicione evento click mostrar modal do btn
  btn.addEventListener("click", mostrarModal);
});

//função mostra modal
function mostrarModal() {
  //adiciona "d-flex", "align-items-center" na lista de clase do staticBackdrop
  staticBackdrop.classList.add("d-flex", "align-items-center");
  //var el recebe documento seletor da consulta id staticBackdrop
  let el = document.querySelector("#staticBackdrop");
  //var minha_modal recebe novo bootstrap
  let minha_modal = new bootstrap.Modal(el);
  // mostra minha modal
  minha_modal.show();
}

//var contante recebe documento seletor da consulta id close-modal
const closeModal = document.querySelector("#close-modal");
// adiciona

// closeModal adiciona evento click na função
closeModal.addEventListener("click", function () {
  // staticBackdrop remove da lista de classe "d-flex", "align-items-center"
  staticBackdrop.classList.remove("d-flex", "align-items-center");
});

//CARROSSEL DEPOIMENTOS

// JÁ VEIO AQUI
// função constante inicializa menu
// const inicializarMenu = () => {
//   //constante menu recebe documento obtido o elemento por id - menu
//   const menu = document.getElementById("menu");
//   // função onclick do menu com parametro btn
//   menu.onclick = (btn) => {
//     // alterne ativo na lista de classe ... btn
//     btn.currentTarget.classList.toggle("active");
//     // constante content recebe documento obtido o elemento por id - menu menu-content
//     const content = document.getElementById("menu-content");
//     // alterne visivel na lista de classe do content
//     content.classList.toggle("visivel");
//     // constante socialIcons recebe documento todos seletores da consulta classe social-link
//     const socialIcons = document.querySelectorAll(".social-link");
//     // para cada icone do socialIcons
//     socialIcons.forEach((icon) => {
//       // alterne branco na lista de classe do icone
//       icon.classList.toggle("white");
//     });
//   };
// };
// // função hide button
// const hideButton = () => {
//   // mostra hideButton
//   console.log("hideButton");
//   // constante btn recebe documento seletor da consulta id check-button
//   const btn = document.querySelector("#check-button");
//   // adicione disabled-link na lista de classe do btn
//   btn.classList.add("disabled-link");
// };
// // função mostra botão
// const showButton = () => {
//   // mostra showButton
//   console.log("showButton");
//   // constante btn recebe documento seletor da consulta id check-button
//   const btn = document.querySelector("#check-button");
//   // remove disabled-link na lista de classe do btn
//   btn.classList.remove("disabled-link");
// };
// // função de adicionar entrada de evento
// const addEventInput = () => {
//   // documento seletor da consulta id wallet-input no teclado
//   document.querySelector("#wallet-input").onkeyup = () => {
//     // var validWallet recebe documento seletor da consulta id wallet-input com contagem dos valres maior que 5
//     let validWallet = document.querySelector("#wallet-input").value.length > 5;
//     // se validWallet chama a função showButton()
//     if (validWallet) showButton();
//     // se não chama a função  hideButton();
//     else hideButton();
//   };
// };
// // adicionar carteira de verificação de eventos
// const addEventCheckWallet = () => {
//   // documento seletor da consulta id check-button no click
//   document.querySelector("#check-button").onclick = () => {
//     // var validWallet recebe documento seletor da consulta id wallet-input com contagem dos valres maior que 5
//     let validWallet = document.querySelector("#wallet-input").value.length > 5;
//     // se validWallet chama a função checkWallet()
//     if (validWallet) checkWallet();
//   };
// };
// // const função verifique a carteira
// const checkWallet = () => {
//   // documento seletor da consulta id #result-text
//   document.querySelector("#result-text").innerHTML = "";
//   // const recebe documento seletor da consulta id wallet-input valor
//   const walletID = document.querySelector("#wallet-input").value;

//   // checked
//   // document.querySelector("#result-text").innerHTML = "you are god to go!";

//   // non checked
//   // document.querySelector("#result-text").innerHTML = "You are not on our whitelist.";
// };

// Valores

// const today = new Date();

// const validity = new Date("2023-06-18 00:00:00");

// const promotionalValue = document.getElementById("section-values-row");

// const fullValue = document.getElementById("section-values-row-full-value");

// const phraseDiscount = document.getElementById("field-unit-price-phrase");

// const phraseValueDiscount = document.getElementById("phrase-value-header-row-discount");

// const phraseValueNormal = document.getElementById("phrase-value-header-row-normal");

// const mostraValor = () => {

// if (today > validity) {

// phraseDiscount.classList.add("d-none");

// promotionalValue.classList.add("d-none");

// fullValue.classList.remove("d-none");

// phraseValueDiscount.classList.add("d-none");

// phraseValueNormal.classList.remove("d-none");

// }
// };
